import React from 'react';
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from '@mui/x-data-grid';
import PropTypes from 'prop-types';
import { useLocalStorage } from 'hooks/useLocalStorage';

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <GridToolbarExport
        printOptions={{ disableToolbarButton: true }} // printing is janky, so we hide it
      />
    </GridToolbarContainer>
  );
}

export function CentsDataGrid({
  tableName,
  data,
  columns,
  onRowClick,
  isLoading,
  defaultColumnVisibilityModel,
  checkboxSelection = false,
  checkboxSelectionVisibleOnly = false,
  onRowSelectionModelChange,
  rowSelectionModel,
}) {
  const storageKey = `COLUMN_VISIBILITY_MODEL-${tableName}`;

  const [columnVisibilityModel, setColumnVisibilityModel] = useLocalStorage(
    storageKey,
    defaultColumnVisibilityModel,
  );

  return (
    <div className="data-grid-container">
      <DataGrid
        components={{ Toolbar: CustomToolbar }}
        checkboxSelection={checkboxSelection}
        checkboxSelectionVisibleOnly={checkboxSelectionVisibleOnly}
        rows={data}
        columns={columns}
        density="compact"
        disableColumnMenu
        onRowClick={onRowClick}
        loading={isLoading}
        columnVisibilityModel={columnVisibilityModel}
        onColumnVisibilityModelChange={(newModel) => setColumnVisibilityModel(newModel)}
        onRowSelectionModelChange={onRowSelectionModelChange}
        rowSelectionModel={rowSelectionModel}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 50 },
          },
        }}
      />
    </div>
  );
}

CentsDataGrid.propTypes = {
  tableName: PropTypes.string,
  // when we switch to typescript, we should use
  // the types from the library for the following prop types
  data: PropTypes.any,
  columns: PropTypes.any,
  onRowClick: PropTypes.func,
  isLoading: PropTypes.bool,
  defaultColumnVisibilityModel: PropTypes.any,
  checkboxSelection: PropTypes.bool,
  checkboxSelectionVisibleOnly: PropTypes.bool,
  onSelectionModelChange: PropTypes.func,
  selectionModel: PropTypes.array,
  onRowSelectionModelChange: PropTypes.func,
  rowSelectionModel: PropTypes.array,
};
